import {usingNonDecimalCurrency} from './localization';

export function roundNumber(num, scale) {
    if (!('' + num).includes('e')) {
        return Number(Number(Math.round(num + 'e+' + scale) + 'e-' + scale).toFixed(scale));
    } else {
        var arr = ('' + num).split('e');
        var sig = '';
        if (Number(arr[1]) + scale > 0) {
            sig = '+';
        }
        return Number(Number(Math.round(Number(arr[0]) + 'e' + sig + (Number(arr[1]) + scale)) + 'e-' + scale).toFixed(scale));
    }
}

export function countDecimals(number) {
    if (number && number.toString().indexOf('.') >= 0) {
        if (Math.floor(number.valueOf()) === number.valueOf()) return 0;
        return number.toString().split(".")[1].length || 0;
    }
    return 0;
}

export function roundNumberForCurrency(num, systemCurrency) {
    let scale = (usingNonDecimalCurrency(systemCurrency)) ? 0 : 2;

    return roundNumber(num, scale);
}



// WEBPACK FOOTER //
// ./src/helpers/mathFunctions.js